import "./interfaces/global";
import * as React from "react";
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { HashRouter } from "react-router-dom";

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

import store from './redux/store';
import Main from "./components/Main";

root.render(
  <HashRouter>
    <Provider store={store}>
      <Main/>
    </Provider>
  </HashRouter>
);